<template>
  <div>
    <v-row>
      <v-col cols="12" md="8">
        <invoice-details
          class="pa-4"
          :details="form"
          :customer="customer"
          :customer-route="customerRouteName"
          :customer-name="customerName"
        ></invoice-details>
      </v-col>
      <v-col cols="12" xs="12" md="4">
        <v-row>
          <v-select
            v-model="form.status_id"
            name="status_id"
            item-value="id"
            item-text="name"
            :items="statusesList"
            :readonly="readonly"
            :disabled="readonly"
            :label="`${$t('ITEM.STATUS')} *`"
            :error-messages="errors.status_id"
            @change="updateValue('status_id', $event)"
          ></v-select>
        </v-row>
        <v-row>
          <v-text-field
            :value="address"
            :label="$t('EREPORTER.INVOICES.BILLING_ADDRESS')"
            :append-icon="isEdit ? 'mdi-square-edit-outline' : ''"
            readonly
            @click:append="$emit('change-address')"
          />
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import formEditable, { EDIT } from '@/modules/_global/mixins/form-editable';
import customerTypes from '@/modules/ereporter/common/Invoices/customerTypes';
import { dateFormat } from '@/modules/_global/filters';
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import statuses from '../../../common/Payrolls/statuses';
import InvoiceDetails from '@/modules/ereporter/components/forms/Invoices/InvoiceDetails';

export default {
  name: 'InvoiceForm',
  components: { InvoiceDetails },
  filters: {
    dateFormat
  },

  mixins: [formEditable, i18nRefreshData],

  props: {
    customerType: {
      type: Number,
      required: true,
      validator: prop => Object.values(customerTypes).includes(prop)
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    address: {
      type: String,
      default: () => ''
    }
  },

  data() {
    return {
      form: {
        status_id: 1
      },
      customerRoutes: {
        [customerTypes.CUSTOMER]: 'persons.show',
        [customerTypes.BUSINESS]: 'companies.show'
      }
    };
  },

  computed: {
    ...mapState('ereporter', ['invoiceStatuses', 'currentInvoice']),

    customerName() {
      return (this.customerType === customerTypes.CUSTOMER
        ? `${this.customer.first_name} ${this.customer.last_name}`
        : this.customer.name
      ).trim();
    },

    customerRouteName() {
      return this.customerRoutes[this.customerType];
    },

    statusesList() {
      return this.invoiceStatuses.map(status => {
        return {
          ...status,
          disabled: !this.enabledStatuses.includes(status.id)
        };
      });
    },

    enabledStatuses() {
      const status = this.currentInvoice.status_id || statuses.OPEN;

      switch (status) {
        case statuses.OPEN:
          return [statuses.OPEN, statuses.READY_TO_SEND, statuses.CANCEL];
        case statuses.READY_TO_SEND:
          return [statuses.OPEN, statuses.READY_TO_SEND];
        case statuses.SENT_TO_ABACUS:
          return [statuses.OPEN, statuses.SENT_TO_ABACUS, statuses.PRINTED];
        case statuses.PRINTED:
          return [statuses.OPEN, statuses.SENT_TO_ABACUS, statuses.PRINTED];
        case statuses.PROBLEM_WITH_ABACUS:
          return [statuses.OPEN, statuses.PROBLEM_WITH_ABACUS];
        case statuses.SENT_VIA_EMAIL:
          return [statuses.OPEN, statuses.SENT_TO_ABACUS];
        case statuses.CANCEL:
          return [statuses.OPEN];
        default:
          return [];
      }
    },

    isEdit() {
      return this.action === EDIT;
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('ereporter', ['getInvoiceStatuses']),
    refreshData() {
      this.getInvoiceStatuses();
    }
  }
};
</script>

<style scoped></style>
